<template>
	<div>
		<WidgetFieldWrapper
			:field="field"
			:key="field.id"
			:previousSteps="{}"
			@update-value="updateValue"
			v-for="field in widgetFields"
			:fieldValue="fieldValue(field.id)"
			:configurationId="configurationId"
			:isGeneralConfiguration="isGeneralConfiguration"
		/>
	</div>
</template>

<script>
import { setConfigurationValues } from '@/store/modules/configurationEditor/actions';
import WidgetFieldWrapper from '@/components/WidgetForm/WidgetFieldWrapper.vue';
import { mapActions, mapGetters } from 'vuex';
import { widget as generalConfWidget } from '@/store/modules/configurationEditor/modules/generalConfigurationWidgetEditor/getters';
import { widget as userConfWidget } from '@/store/modules/configurationEditor/modules/userConfigurationWidgetEditor/getters';
import { editedWorkflowVersion } from '@/store/modules/selectedWorkflow/getters';
import { READ_ONLY_WIDGET_FIELDS } from '@/components/BlockEditorWidget/widgetFieldTypes.const';
import { getConfiguration as getConfigurationAction } from '@/store/modules/workflowConfigurations/actions';
import { getConfiguration } from '@/store/modules/workflowConfigurations/getters';
import WidgetFieldService from '@/components/BlockEditorWidget/WidgetFieldService';
export default {
	name: 'FillConfigurationInterface',
	props: {
		widget: { type: Object },
		configurationId: { type: Number },
		interfaceId: { type: [Number, String] },
		isGeneralConfiguration: { type: Boolean },
	},
	components: {
		WidgetFieldWrapper,
	},
	methods: {
		...mapActions([getConfigurationAction.fullPath, setConfigurationValues.fullPath]),
		setInitialsFieldValues() {
			const { fields } = this.widget;
			fields
				.filter((field) => !READ_ONLY_WIDGET_FIELDS.includes(field.field_type))
				.forEach((widgetField) => {
					const value =
						widgetField.id in this.fieldsResponsesMap
							? this.fieldsResponsesMap[widgetField.id]
							: WidgetFieldService.getDefaultValueOfField(widgetField, {}, {});
					this.updateFieldValue({ id: widgetField.id, value }, true);
				});
		},
		updateFieldValue(payload, fromInitialize) {
			this.setFieldValue(payload);
			this.handleValueUpdate(payload, fromInitialize);
		},
		updateValue(payload) {
			this.updateFieldValue(payload);
		},
		fieldValue(fieldId) {
			return this.fieldsValues[fieldId];
		},
		setFieldValue(payload) {
			const { id, value } = payload;
			this.$set(this.fieldsValues, id, value);
		},
		handleValueUpdate({ id, value }) {
			this.fieldsResponses[id] = value;
		},
	},
	computed: {
		...mapGetters([getConfiguration.fullPath]),
		...mapGetters([editedWorkflowVersion.fullPath, userConfWidget.fullPath, generalConfWidget.fullPath]),
		userResponse() {
			return this.configuration.user_response;
		},
		fieldsResponsesMap() {
			return this.userResponse?.fields_responses || {};
		},
		configuration() {
			return this[getConfiguration.fullPath](this.configurationId);
		},
		configurationInterface() {
			const interfaceObject = { ...this.configuration.workflow_configuration_interfaces[0].interface };
			// in case we want to ignore user's response (eg. install installable - we want to ignore previous responses)
			if (!this.omitResponse) {
				interfaceObject.fields = interfaceObject.fields.map((field) => ({
					...field,
					currentUserResponse: this.fieldsResponsesMap[field.id],
				}));
			}
			return interfaceObject;
		},
		widgetFields() {
			return this.widget?.fields || [];
		},
	},
	async mounted() {
		if (this.widget) {
			this.setInitialsFieldValues();
		}
	},
	watch: {
		widget(newV, oldV) {
			// Do not delete, this is called when it takes a moment for the widget to arrive
			if (!oldV && newV) {
				this.setInitialsFieldValues();
			}
		},
		fieldsValues: {
			handler(newV) {
				this[setConfigurationValues.fullPath]({ [this.configurationId]: { [this.interfaceId]: newV } });
			},
			deep: true,
		},
	},
	data() {
		return {
			fieldsValues: {},
			fieldsResponses: {},
		};
	},
};
</script>

<style lang="scss" scoped></style>
